import { useState, useEffect } from "react";
import Input from "../../input";
import StatusModal from "components/StatusModal";
import { useDisclosure, Portal } from "@chakra-ui/react";

export default function Confirm({
  bank,
  setBank,
  accountName,
  setAccountName,
  accountNumber,
  setAccountNumber,
}) {
  const [err, setErr] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleErrChange = () => {
    setErr(false);
    onOpen();
  }

  return (
    <div>
      <div className="grid grid-cols-1 gap-y-2 mb-6 font-medium">
        <div className="flex justify-between">
          <span>Bank</span>
          <span>{bank}</span>
        </div>

        <div className="flex justify-between">
          <span>Account number</span>
          <span>{accountNumber}</span>
        </div>

        <div className="flex justify-between">
          <span>Account name</span>
          <span>{accountName}</span>
        </div>
      </div>

      <div>
        <Input type="number" label="Enter Pin" id="pin" required />

        <div className="mt-12 flex justify-end" onClick={handleErrChange}>
          <button className="bg-[#4285F4] text-base text-white font-bold px-6 py-2.5">
            Confirm
          </button>
        </div>
      </div>

      {err ? (
        <StatusModal
          isOpen={isOpen}
          onClose={onClose}
          text={err}
          status="Failed"
          samePageNav
          navigateTo={undefined}
        />
      ) : (
        <StatusModal
          isOpen={isOpen}
          onClose={onClose}
          text="Your bank has been linked to your profile."
          navigateTo="/app/account"
          status={undefined}
          samePageNav={undefined}
        />
      )}
    </div>
  );
}
